import { languagesList, intervalDaysOptions, acceptDaysOptions, autoExtendMonthOptions, languages, googleApiKey } from './serialized.js.erb'

export { languagesList, intervalDaysOptions, acceptDaysOptions, autoExtendMonthOptions, languages, googleApiKey }
